import styled, { css } from 'styled-components';

type HeaderContainerAttributes = {
  $background: string;
};

export const HeaderContainer = styled.div<HeaderContainerAttributes>(
  ({ $background }: HeaderContainerAttributes) => css`
    background-image: url('${$background}');

    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
    background-repeat: no-repeat;
    background-position: center;

    background-size: cover;
    position: relative;
    overflow: hidden;
    height: 100%;

    > img:only-child {
      margin: auto auto 0px;
      position: absolute;
      max-height: 100%;
      width: auto;
      inset: 0px;
    }
  `
);

export const HotspotContent = styled.div`
  text-align: center;
  padding: 30px 20px;

  > h2 {
    text-wrap: balance;
  }

  > p {
    margin-block: 22px 30px;
  }
`;
